/**
 * Fabpad category tiles — mobile scroll indicator dots.
 */
(function () {
  'use strict';

  var section = document.querySelector('[data-fabpad-category-tiles]');
  if (!section) return;

  var scrollEl = section.querySelector('[data-category-scroll]');
  var dotsWrap = section.querySelector('[data-category-dots]');
  if (!scrollEl || !dotsWrap) return;

  var dots = dotsWrap.querySelectorAll('[data-category-dot]');
  var tiles = scrollEl.querySelectorAll('.fabpad-cat-tiles__tile');
  if (!dots.length || !tiles.length) return;

  function getActiveIndex() {
    var scrollLeft = scrollEl.scrollLeft;
    var closestIndex = 0;
    var closestDistance = Infinity;

    tiles.forEach(function (tile, index) {
      var distance = Math.abs(tile.offsetLeft - scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function updateDots() {
    var index = getActiveIndex();
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === index);
    });
  }

  scrollEl.addEventListener('scroll', updateDots, { passive: true });
  window.addEventListener('resize', updateDots, { passive: true });
  updateDots();
})();
